import React from "react";
import TableImportSchedule from "../table/TableImportSchedule";

import { tr } from "../../i18n";
const ModalImportSchedule = ({ show, onClose, onSelect }) => {
  if (!show) return null; // modal hidden

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-md"
        onClick={(e) => e.stopPropagation()} // biar klik dalam modal tidak close
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{tr("attendance:import_schedule_template")}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body p-0 pt-3 pb-3">
            {/* === BUTTON CREATE TEMPLATE === */}
            <div className="d-flex justify-content-end px-3 mb-2">
              <a
                href="/schedules/form"
                className="btn btn-sm btn-primary"
                style={{ fontWeight: 600 }}
              >
                {tr("attendance:create_template")}
              </a>
            </div>

            {/* TABLE */}
            <TableImportSchedule
              onSelect={(data) => {
                onSelect(data);
                onClose();
              }}
            />
          </div>

          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              {tr("common:actions.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalImportSchedule;
